var _g, _g2, _g3, _g4, _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _g5, _path13, _g6, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _g7, _path23, _path24;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnsupportedBrowser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 451.434,
    height: 421.254,
    viewBox: "0 0 451.434 421.254",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-336.028 -357.802)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(357.839 693.357)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(7 21.192)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M344.9,155.516c-76.79-12.595-201.33-12.595-278.128,0s-76.79,33.018,0,45.613,201.33,12.6,278.128,0S421.7,168.113,344.9,155.516Z",
    transform: "translate(-9.176 -146.07)",
    fill: "#0e3689"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(482.791 716.477)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(7 21.192)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.735,147.281c-30.092-1.614-78.894-1.614-108.989,0s-30.092,4.232,0,5.846,78.894,1.615,108.989,0S170.83,148.9,140.735,147.281Z",
    transform: "translate(-9.176 -146.07)",
    fill: "#082258"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(222 296.197)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M552.2,66.635H127.291A13.263,13.263,0,0,0,114.028,79.9V383.019a13.263,13.263,0,0,0,13.263,13.264H290.37s10.373,32.078-21.784,48.675H421.073s-36.308-12.447-26.972-48.675H552.2a13.263,13.263,0,0,0,13.263-13.263V79.9A13.263,13.263,0,0,0,552.2,66.635",
    fill: "#747474"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.418,363.966c5.78,8.261-3.266,17.307-11.529,11.529a2.932,2.932,0,0,1-.71-.713c-5.764-8.259,3.271-17.293,11.528-11.527a2.91,2.91,0,0,1,.711.711",
    fill: "#bababa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.146,340.625h-436.8V84.078a9.7,9.7,0,0,1,9.7-9.7H548.449a9.7,9.7,0,0,1,9.7,9.7Z",
    fill: "#001531"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.146,96.5h-436.8V83.534A9.154,9.154,0,0,1,130.5,74.38H550.63a7.516,7.516,0,0,1,7.516,7.516Z",
    fill: "#434343"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.322,85.906a3.069,3.069,0,1,1-3.068-3.068,3.068,3.068,0,0,1,3.068,3.068",
    fill: "#bababa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.47,85.906a3.069,3.069,0,1,1-3.068-3.068,3.068,3.068,0,0,1,3.068,3.068",
    fill: "#bababa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.168,85.906a3.068,3.068,0,1,1-3.068-3.068,3.068,3.068,0,0,1,3.068,3.068",
    fill: "#bababa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.232,395.572c0,.141-60.465.255-135.034.255-74.6,0-135.048-.114-135.048-.255s60.452-.255,135.048-.255c74.569,0,135.034.114,135.034.255",
    fill: "#455a64"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-220.601 51.662)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(754.232 392.125)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(63.433)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1745.012,590.906l-1.393,62.239-6.062,33.507-13.382-.1-4.521-.035-21.483-.162-1.812-20.431-2.576-65.211Z",
    transform: "translate(-1693.784 -590.906)",
    fill: "#8fb3e3"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(118.64 16.944)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2028.028,760.632h-10.157l-29.118-.159.419-23.278,1-55.754,34.356,11.641,2.287,44.113Z",
    transform: "translate(-1988.753 -681.44)",
    fill: "#8fb3e3"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 33.037)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1412.156,776.364v53.289l-18.221-.177-36.465-.348-2.609-61.706Z",
    transform: "translate(-1354.861 -767.421)",
    fill: "#8fb3e3"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(93.825 35.571)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1935.129,800.414v41.114H1910.1l-29.118-.279-11.433-.111-13.382-.126.727-60.048Z",
    transform: "translate(-1856.167 -780.964)",
    fill: "#8fb3e3"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(164.01 27.435)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2261.8,737.489l0,.145.395,64.916-31.027,3.641.778-30.528.868-34.234Z",
    transform: "translate(-2231.166 -737.489)",
    fill: "#8fb3e3"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(39.074 69.187)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1613.865,960.573V986.96l-21.483-.207-10.525-.1-18.221-.177v-25.9Z",
    transform: "translate(-1563.636 -960.573)",
    fill: "#8fb3e3"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(96.477 9.558)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1874.356,648.807l-3.81-.447-.208-6.161,4.018-.225Z",
    transform: "translate(-1870.338 -641.974)",
    fill: "#9fc4eb"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(131.297 38.564)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2060.4,803.786l-3.81-.447-.208-6.161,4.018-.225Z",
    transform: "translate(-2056.381 -796.954)",
    fill: "#9fc4eb"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(96.477 55.021)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1874.356,891.718l-3.81-.447-.208-6.161,4.018-.225Z",
    transform: "translate(-1870.338 -884.885)",
    fill: "#9fc4eb"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(89.305 41.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1836.039,819.474l-3.81-.447-.208-6.161,4.019-.225Z",
    transform: "translate(-1832.02 -812.641)",
    fill: "#9fc4eb"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(615.934 346.355)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(59.778 33.218)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M983.771,523.839l-1.105,67.574-.643,39.391-13.405-.129-4.521-.045-21.577-.2L940.8,605.579l-5.475-79.139,10.1-.544,25.84-1.387Z",
    transform: "translate(-935.326 -523.839)",
    fill: "#8fb3e3"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(117.897 2.987)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1285.083,500l-16.215-.156-15.82-.153-7.19-.069.405-39.5,1-97.805,34.356,20.421,2.287,77.385Z",
    transform: "translate(-1245.858 -362.313)",
    fill: "#8fb3e3"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 78.024)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M672.473,763.953v60.966l-24.24-.074-32.3-.1.738-28.862.847-32.64Z",
    transform: "translate(-615.934 -763.241)",
    fill: "#8fb3e3"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(93.068 88.427)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1192.162,818.82V871.2l-8.761-.11-6.149-.075-16.215-.2-15.82-.2-7.19-.091-11.423-.142-13.405-.169V818.82Z",
    transform: "translate(-1113.2 -818.82)",
    fill: "#8fb3e3"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(163.27 57)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1513.207,650.909l0,.179-.914,83.778-1.547-.014-8.352-.074-5.342-.047-8.76-.077.616-36.611.707-42.269Z",
    transform: "translate(-1488.289 -650.909)",
    fill: "#8fb3e3"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(40.894 114.957)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M882.083,960.573v25.051l-21.577-.2-10.432-.1-6.708-.063-8.938-.087.2-24.595Z",
    transform: "translate(-834.429 -960.573)",
    fill: "#8fb3e3"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(68.93 29.013)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1011.019,510.18H985.567l-1.34-8.809h26.791Z",
    transform: "translate(-984.228 -501.371)",
    fill: "#8fb3e3"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(77.441 11.846)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1040.811,431.218H1029.7v-20.8l11.917-.767Z",
    transform: "translate(-1029.703 -409.646)",
    fill: "#8fb3e3"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.991)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2.009,
    height: 20.805,
    fill: "#8fb3e3"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(67.591 42.251)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M981.089,578.711h-3.8l-.223-6.608,4.019.405Z",
    transform: "translate(-977.071 -572.103)",
    fill: "#9fc4eb"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(95.721 55.328)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1131.39,648.807l-3.81-.447-.208-6.161,4.019-.225Z",
    transform: "translate(-1127.371 -641.974)",
    fill: "#9fc4eb"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(145.06 49.381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1395.012,617.033l-3.81-.447-.208-6.161,4.018-.225Z",
    transform: "translate(-1390.993 -610.2)",
    fill: "#9fc4eb"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(126.522 60.94)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1295.961,678.792l-3.81-.447-.208-6.161,4.019-.225Z",
    transform: "translate(-1291.943 -671.959)",
    fill: "#9fc4eb"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(130.541 84.334)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1317.433,803.786l-3.81-.447-.208-6.161,4.019-.225Z",
    transform: "translate(-1313.414 -796.954)",
    fill: "#9fc4eb"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(95.721 100.792)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1131.39,891.718l-3.81-.447-.208-6.161,4.019-.225Z",
    transform: "translate(-1127.371 -884.885)",
    fill: "#9fc4eb"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.549 87.27)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1093.072,819.474l-3.81-.447-.208-6.161,4.018-.225Z",
    transform: "translate(-1089.053 -812.641)",
    fill: "#9fc4eb"
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 437,
    height: 110,
    transform: "translate(343 527)",
    fill: "#4d4d4d"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10570.3,22170.078l35.559-.078,74.3,96.861-61.442.139ZM10486.45,22267l30.518-97h28l24.27,97Zm-109.86-.139,74.3-96.861,35.559.078-48.411,96.922Zm-72.541.043V22226.7l83.623-56.773,39.4.084-113.983,96.916Zm329.479-96.9,37.206-.084,70.317,50.563v46.348Z",
    transform: "translate(-9961.051 -21630)",
    fill: "#fff",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-173.098 -86.643)"
  }, /*#__PURE__*/React.createElement("g", null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M805.945,577.658h-5a3.924,3.924,0,0,0-3.913,3.63l-.946,12.57H810.8l-.946-12.57A3.924,3.924,0,0,0,805.945,577.658Z",
    fill: "#ffb048"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M806.575,589.322c-4.064,0-7.438-4.632-8.143-10.738a3.9,3.9,0,0,0-1.4,2.7l-.946,12.57H810.8l-.45-5.987A5.967,5.967,0,0,1,806.575,589.322Z",
    fill: "#e5772e"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M807.153,593.272c0-7.182-1.543-13-3.446-13-1.37,0-2.55,3.023-3.1,7.391l-.279,6.2h6.822C807.148,593.662,807.153,593.47,807.153,593.272Z",
    fill: "#ffd066",
    opacity: 0.62,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.263,0H23.48a4.263,4.263,0,0,1,4.263,4.263V7.514a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V4.263A4.263,4.263,0,0,1,4.263,0Z",
    transform: "translate(789.573 592.405)",
    fill: "#473b39"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M804.167,599.052l-2.89-.578v99.991h4.335Z",
    fill: "#473b39"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.479,0H26.153a4.479,4.479,0,0,1,4.479,4.479V7.514a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V4.479A4.479,4.479,0,0,1,4.479,0Z",
    transform: "translate(788.128 694.129)",
    fill: "#704741"
  }))), /*#__PURE__*/React.createElement("g", null, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M667.615,577.658h-5a3.924,3.924,0,0,0-3.913,3.63l-.946,12.57h14.72l-.947-12.57A3.924,3.924,0,0,0,667.615,577.658Z",
    fill: "#ffb048"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M668.245,589.322c-4.064,0-7.438-4.632-8.143-10.738a3.9,3.9,0,0,0-1.4,2.7l-.946,12.57h14.719l-.45-5.987A5.967,5.967,0,0,1,668.245,589.322Z",
    fill: "#e5772e"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M668.823,593.272c0-7.182-1.543-13-3.446-13-1.37,0-2.55,3.023-3.105,7.391l-.279,6.2h6.822C668.818,593.662,668.823,593.47,668.823,593.272Z",
    fill: "#ffd066",
    opacity: 0.62,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4.263,0H23.48a4.263,4.263,0,0,1,4.263,4.263V7.514a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V4.263A4.263,4.263,0,0,1,4.263,0Z",
    transform: "translate(651.243 592.405)",
    fill: "#473b39"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M665.837,599.052l-2.89-.578v99.991h4.335Z",
    fill: "#473b39"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M4.479,0H26.153a4.479,4.479,0,0,1,4.479,4.479V7.514a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V4.479A4.479,4.479,0,0,1,4.479,0Z",
    transform: "translate(649.798 694.129)",
    fill: "#704741"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M3.131,0H176.043a3.131,3.131,0,0,1,3.131,3.131V26.539a3.131,3.131,0,0,1-3.131,3.131H3.131A3.131,3.131,0,0,1,0,26.539V3.131A3.131,3.131,0,0,1,3.131,0Z",
    transform: "translate(645.511 595.487)",
    fill: "#0651f1"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M665.142,595.487l-14.625,29.67h20.518l14.626-29.67Z",
    fill: "#ffd7b0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M709.935,595.487l-14.625,29.67h20.518l14.626-29.67Z",
    fill: "#ffd7b0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M754.729,595.487,740.1,625.157h20.518l14.625-29.67Z",
    fill: "#ffd7b0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M799.522,595.487,784.9,625.157h20.518l14.626-29.67Z",
    fill: "#ffd7b0"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M3.131,0H176.043a3.131,3.131,0,0,1,3.131,3.131V26.539a3.131,3.131,0,0,1-3.131,3.131H3.131A3.131,3.131,0,0,1,0,26.539V3.131A3.131,3.131,0,0,1,3.131,0Z",
    transform: "translate(645.511 646.061)",
    fill: "#0651f1"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M665.142,646.061l-14.625,29.67h20.518l14.626-29.67Z",
    fill: "#ffd7b0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M709.935,646.061l-14.625,29.67h20.518l14.626-29.67Z",
    fill: "#ffd7b0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M754.729,646.061,740.1,675.731h20.518l14.625-29.67Z",
    fill: "#ffd7b0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M799.522,646.061,784.9,675.731h20.518l14.626-29.67Z",
    fill: "#ffd7b0"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M821.555,646.061h-3.42v23.5a3.04,3.04,0,0,1-3.039,3.04H652.308a3.04,3.04,0,0,1-3.04-3.04v-23.5h-.626a3.13,3.13,0,0,0-3.131,3.13V672.6a3.131,3.131,0,0,0,3.131,3.131H821.555a3.13,3.13,0,0,0,3.13-3.131V649.191A3.13,3.13,0,0,0,821.555,646.061Z",
    fill: "#822a2a",
    opacity: 0.51,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M821.555,595.487h-.53v22.84a3.073,3.073,0,0,1-3.073,3.073H651.474a3.073,3.073,0,0,1-3.073-3.073V595.512a3.121,3.121,0,0,0-2.89,3.106v23.408a3.131,3.131,0,0,0,3.131,3.131H821.555a3.13,3.13,0,0,0,3.13-3.131V598.618A3.13,3.13,0,0,0,821.555,595.487Z",
    fill: "#822a2a",
    opacity: 0.51,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-497.309 -103.525)"
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M925.075,637.319h-5.407a4.549,4.549,0,0,0-4.233,4.533l-1.023,15.7h15.919l-1.023-15.7A4.549,4.549,0,0,0,925.075,637.319Z",
    fill: "#e5772e"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M928.1,652.276H916.639c-4.709,0-8.621,4.19-8.974,9.611l-2.17,33.281h33.753l-2.17-33.281C936.725,656.466,932.813,652.276,928.1,652.276Z",
    fill: "#ffd7b0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M906.262,683.407h32.22L937.4,666.8H907.344Z",
    fill: "#0651f1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M929.061,690.7c-7.826.934-15.088-7.056-16.561-23.525a58.375,58.375,0,0,1,.365-13.932,10.454,10.454,0,0,0-5.2,8.643l-2.17,33.281h33.753l-.791-12.135C936.306,687.608,932.986,690.233,929.061,690.7Z",
    fill: "#822a2a",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M938.523,693.785h-32.3a6.611,6.611,0,0,0-4.988,2.386l-5.923,6.838h54.125l-5.923-6.838A6.611,6.611,0,0,0,938.523,693.785Z",
    fill: "#0651f1"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M929.308,641.852a4.549,4.549,0,0,0-4.233-4.533h-5.407a3.882,3.882,0,0,0-2.649,1.1c.067,6.739,3.4,12.17,7.516,12.17,1.983,0,3.781-1.271,5.125-3.333Z",
    fill: "#ffb048"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M919.469,643.712c.894,3.314,2.909,5.626,5.255,5.626a3.849,3.849,0,0,0,2.155-.692c-.487-4.259-2.267-7.422-4.4-7.422C921.324,641.224,920.27,642.17,919.469,643.712Z",
    fill: "#ffd066"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M943.511,696.171a7.231,7.231,0,0,0-.7-.7c-1.963,3.847-10.277,4.539-16.942,4.539-8.847,0-21.171-.461-20.218-6.194a6.683,6.683,0,0,0-4.417,2.354l-5.923,6.838h54.125Z",
    fill: "#822a2a",
    opacity: 0.51,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(155.485 301.869)"
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M543.724,76.462h-2.776l.617,235.509h3.815Z",
    transform: "translate(-6.864 -3.357)",
    fill: "#473b39"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M571.492,92.231,540.159,57.791a5.411,5.411,0,0,0-8.162,0L500.663,92.231a6.8,6.8,0,0,0,0,8.972L532,135.644a5.412,5.412,0,0,0,8.162,0L571.492,101.2A6.8,6.8,0,0,0,571.492,92.231Z",
    fill: "#ce994b"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M565.687,94.8l-24.874-27.34a4.294,4.294,0,0,0-6.479,0L509.459,94.8a5.4,5.4,0,0,0,0,7.123l24.874,27.341a4.3,4.3,0,0,0,6.479,0l24.874-27.341A5.4,5.4,0,0,0,565.687,94.8Z",
    transform: "translate(-1.495 -1.643)",
    fill: "#f4e7d7"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(531.603 83.666)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M537.982,92.331V89.087h8.949v3.244l-1.23,13.611h-6.489Zm8.166,16.333v6.525H538.8v-6.525Z",
    transform: "translate(-537.982 -89.087)",
    fill: "#473b39"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M531.6,102.431a50.98,50.98,0,0,1-20.676,10.006l16.328,17.948a51.122,51.122,0,0,1,47.142-34.669,6.358,6.358,0,0,0-.948-1.381L550.21,68.794A49.057,49.057,0,0,1,531.6,102.431Z",
    transform: "translate(-1.954 -2.103)",
    fill: "#ffecc6",
    opacity: 0.439,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M5,0H56V27H0Z",
    transform: "translate(356 500)",
    fill: "#48648a"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0H49L46,27H0Z",
    transform: "translate(718 500)",
    fill: "#48648a"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnsupportedBrowser);
export default __webpack_public_path__ + "static/media/unsupported-browser.bbf1eee082e9ff422c97a70aee59c39d.svg";
export { ForwardRef as ReactComponent };